import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.85938 5.58057C5.85938 5.58057 11.5158 10.9676 15.1402 14.4194"
      stroke="white"
      strokeWidth={1.33}
    />
    <path
      d="M15.1406 5.58057C15.1406 5.58057 9.48422 10.9676 5.85985 14.4194"
      stroke="white"
      strokeWidth={1.33}
    />
  </svg>
);
export default SVGComponent;
